module.exports = __webpack_public_path__ + "img/2.86b4f4db.svg";